import { NavItem } from '../types';

export const navItems: NavItem[] = [
  {
    label: 'Accueil',
    path: '/'
  },
  {
    label: 'À Propos',
    path: '/a-propos'
  },
  {
    label: 'Services',
    path: '/services'
  },
  {
    label: 'Réservation',
    path: '/reservation'
  },
  {
    label: 'Bons Cadeaux',
    path: '/bons-cadeaux'
  },
  {
    label: 'Forfaits',
    path: '/forfaits'
  },
  {
    label: "Mag'Moman",
    path: '/blog'
  },
  {
    label: 'FAQ',
    path: '/faq'
  },
  {
    label: 'Contact',
    path: '/contact'
  }
];